import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { downloadFile } from 'atpjs/helpers/file'
import Progress from 'tve/components/document_list/progress'
import { downloadDocument } from 'tve/api/atp'

class DocumentListItem extends Component {
  static propTypes = {
    document: function(props, propName, componentName) {
      if (Map.isMap(props[propName])) return null
      return new Error(`Invalid prop "${propName}" supplied to "${componentName}" is not a immutable.map`)
    },
    deleteHandler: PropTypes.func.isRequired
  }

  downloadDocument = (event) => {
    event.preventDefault()
    const { document } = this.props
    downloadDocument(document.get('url')).then(downloadFile(document.get('filename')))
  }

  deleteDocument = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const { deleteHandler, document } = this.props
    /* eslint-disable no-alert, no-console */
    if (confirm('Dokument löschen?', 'Dokument wirklich löschen?')) deleteHandler(document)
    /* eslint-enable no-alert, no-console */
  }

  render() {
    const { document } = this.props
    return (
      <div className="atp-summary__document--container" onClick={this.downloadDocument}>
        <span className="atp-summary__document--document-icon" />
        <div className="atp-summary__document--text">
          <span>{document.get('filename')}</span>
          {document.get('isUploaded') && <span className="atp-summary__document--uploaded">hochgeladen</span>}
          {document.get('isUploading') && (
            <span className="atp-summary__document--uploading">
              in progress <Progress promise={document.get('promise')} />
            </span>
          )}
          {document.get('error') && <span className="atp-summary__document--failed">Fehler aufgetretten</span>}
        </div>
        <div className="atp-summary__document--delete" onClick={this.deleteDocument}></div>
      </div>
    )
  }
}

export default DocumentListItem
